/* eslint-disable react/destructuring-assignment,react/jsx-no-bind */
import React, { Component } from 'react';
import { connect } from 'dva';
import moment from 'moment';
import { Form, Row, Col, Radio, TimePicker, Button, message, TreeSelect, Spin } from 'antd';
import Container from '../../../../../components/Container';
import { getAppCode } from '../../utils/utils';
import styles from './index.less';

@connect()
class PushSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detail: {
        ispush: '',
        pushTime: '',
        channelids: '',
      },
      treeData: [],
      treeValue: [],
      appCode: getAppCode(),
      spinning: false,
    };
  }

  componentDidMount() {
    this.handleInitPushSetting();
  }

  handleInitPushSetting = () => {
    const { dispatch } = this.props;
    const { appCode } = this.state;
    const me = this;
    const getChannel = new Promise((resolve, reject) => {
      dispatch({
        type: 'pushSettings/fetchChannelList',
        params: { appCode },
      })
        .then(
          res => {
            resolve(res);
          },
          error => {
            console.log(error);
            reject('获取栏目列表失败');
          }
        )
        .catch(e => {
          console.log(e);
        });
    });
    const getDetail = new Promise((resolve, reject) => {
      dispatch({
        type: 'pushSettings/fetchPushConfigInfo',
        params: {
          appCode: getAppCode(),
        },
      })
        .then(
          res => {
            resolve(res);
          },
          err => {
            reject('获取详情失败');
          }
        )
        .catch(e => {
          console.log(e);
        });
    });

    this.setState({ spinning: true });

    Promise.all([getChannel, getDetail])
      .then(result => {
        const treeData = [];
        const detail = result[1];
        result[0].forEach((item, index) => {
          if (item.channelTypeName !== '二级栏目') {
            treeData.push({
              value: String(item.id),
              label: item.name,
              children: [],
            });
            if (
              index + 1 <= result[0].length - 1 &&
              result[0][index + 1].channelTypeName === '二级栏目'
            ) {
              treeData[treeData.length - 1].children = me.handleTreeList(
                result[0],
                index + 1,
                item.id
              );
            }
          }
        });
        this.setState({
          treeData,
          treeValue: detail.channelids ? detail.channelids.split(',') : [],
          detail,
          spinning: false,
        });
      })
      .catch(err => {
        console.log(err);
        this.setState({ spinning: false });
      });
  };

  handleTreeList = (list, index, id) => {
    const res = [];
    for (let i = index; i < list.length; i++) {
      if (list[i].superiorChannelid === id) {
        res.push({
          value: String(list[i].id),
          label: list[i].name,
        });
      }
    }
    return res;
  };

  handlePushSettingSave = () => {
    const { dispatch } = this.props;
    const { detail } = this.state;
    this.setState({ spinning: true });
    dispatch({
      type: 'pushSettings/fetchPushConfigSave',
      params: {
        ...detail,
        appCode: getAppCode(),
      },
    })
      .then(() => {
        message.success('修改成功');
        this.setState({ spinning: false });
        this.handleInitPushSetting();
      })
      .catch(e => {
        console.log(e);
      });
  };

  handleTimePickerChange = (timeObject, pushTime) => {
    const { detail } = this.state;
    this.setState({
      detail: { ...detail, pushTime },
    });
  };

  handleFormSubmit = e => {
    e.preventDefault();
    const { form } = this.props;
    const me = this;
    const { detail, treeValue } = this.state;
    form.validateFields((err, fieldsValue) => {
      if (!err) {
        const { ispush } = fieldsValue;
        me.setState(
          {
            detail: {
              ...detail,
              ispush,
              channelids: treeValue && treeValue.length > 0 ? treeValue.join(',') : '',
              treeValue,
            },
          },
          () => {
            me.handlePushSettingSave();
          }
        );
      }
      form.resetFields();
    });
  };

  handleRadioChange = event => {
    const { detail } = this.state;
    this.setState({
      detail: {
        ...detail,
        ispush: event.target.value,
      },
    });
  };

  handleChangeChannel = value => {
    this.props.form.setFieldsValue({
      channelids: value,
    });

    this.setState({
      treeValue: value,
    });
  };

  render() {
    const { detail, treeData, treeValue, spinning } = this.state;

    const { getFieldDecorator, getFieldProps } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 3 },
      wrapperCol: { span: 16 },
    };

    const { ispush, pushTime } = detail || {};

    const footerProps = {
      states: true,
      demFooter: (
        <Button
          type="primary"
          onClick={e => this.handleFormSubmit(e)}
          disabled={ispush === 1 && (!pushTime || treeValue.length <= 0)}
        >
          保存
        </Button>
      ),
    };

    const treeProps = {
      treeData,
      value: treeValue,
      multiple: true,
      treeDefaultExpandAll: true,
      treeCheckable: true,
      onChange: this.handleChangeChannel,
      notFoundContent: '未找到',
      disabled: ispush === 0,
      getPopupContainer: () => document.getElementById('tree-select'),
      styles: {
        border: '1px solid red',
      },
    };

    return (
      <Container breStates={!0} version={2} footerParams={footerProps}>
        <div className={styles.root}>
          <section className="create-button">
            <h4>自动推送设置</h4>
            <p>开启自动推送，会在所设置的时间进行推送。</p>
            <p>
              推送内容为所选栏目中新发布于24小时内的未推送文章，当新文章多于8篇时会推送最新的8篇，当新文章少于8篇时仅推送未推送过的文章，设置隔天生效。
            </p>
          </section>
          <Spin spinning={spinning}>
            <Form {...formItemLayout}>
              <Row>
                <Col span={24}>
                  <Form.Item {...formItemLayout} label="是否开启">
                    {getFieldDecorator('ispush', {
                      initialValue: ispush,
                    })(
                      <Radio.Group onChange={this.handleRadioChange}>
                        <Radio value={1}>开启自动推送</Radio>
                        <Radio value={0}>关闭自动推送</Radio>
                      </Radio.Group>
                    )}
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item {...formItemLayout} label="自动推送时间">
                    <TimePicker
                      value={pushTime ? moment(pushTime, 'HH:mm') : ''}
                      disabled={ispush === 0}
                      placeholder="推送时间"
                      onChange={this.handleTimePickerChange}
                      format="HH:mm"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24} id="tree-select">
                  <Form.Item {...formItemLayout} label="自动推送栏目">
                    <TreeSelect
                      {...getFieldProps('channelids', {
                        rules: [
                          {
                            type: 'array',
                          },
                        ],
                      })}
                      {...treeProps}
                      style={{ width: 520, maxHeight: 500 }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Spin>
        </div>
      </Container>
    );
  }
}

export default Form.create()(PushSettings);
